import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useFormContext } from '@afosto/app-components-react/Form';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CurrencyField from '@afosto/app-components-react/CurrencyField';
import DateTimePicker from '@afosto/app-components-react/DateTimePicker';
import Icon from '@afosto/app-components-react/Icon';
import Select from '@afosto/app-components-react/Select';
import TextField from '@afosto/app-components-react/TextField';
import ToggleButtonGroup from '@afosto/app-components-react/ToggleButtonGroup';
import translations from './translations';

const DefaultFormSection = () => {
  const intl = useIntl();
  const formContext = useFormContext();
  const [typeSuggestions] = useState([
    { label: intl.formatMessage(translations.types.handling), value: 'handling' },
    { label: intl.formatMessage(translations.types.shipping), value: 'shipping' },
  ]);

  const { watch } = formContext;
  const isPercentageValue = watch('isPercentage');

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardContent>
        <TextField name="name" label={intl.formatMessage(translations.fields.name.label)} />

        <Select
          name="type"
          label={intl.formatMessage(translations.fields.type.label)}
          suggestions={typeSuggestions}
        />

        <TextField
          name="priority"
          label={intl.formatMessage(translations.fields.priority.label)}
          type="number"
          inputProps={{
            min: 0,
          }}
        />

        <ToggleButtonGroup
          name="isPercentage"
          margin="none"
          options={[
            {
              label: <Icon icon={['fal', 'euro-sign']} size="small" />,
              value: false,
            },
            {
              label: <Icon icon={['fal', 'percentage']} size="small" />,
              value: true,
            },
          ]}
          fullWidth={false}
        />

        {isPercentageValue ? (
          <TextField
            name="amount"
            label={intl.formatMessage(translations.fields.percentage.label)}
            type="number"
            inputProps={{
              min: 0,
            }}
          />
        ) : (
          <CurrencyField
            name="amount"
            label={intl.formatMessage(translations.fields.amount.label)}
            inputProps={{
              min: 0,
            }}
          />
        )}

        <DateTimePicker
          name="activeAt"
          label={intl.formatMessage(translations.fields.activeAt.label)}
          disableFuture={false}
        />

        <DateTimePicker
          name="expiresAt"
          label={intl.formatMessage(translations.fields.expiresAt.label)}
          disableFuture={false}
        />
      </CardContent>
    </Card>
  );
};

export default DefaultFormSection;
